import React, { Suspense } from 'react';
import './i18n';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Loader } from 'Components/UI';
import TicketJotai from 'Providers/TicketJotai';
import {
  Ticket,
  Payment,
  PaymentForm,
  ShareNote,
  Calculator,
  ShareNoteProduct,
  RequestTicket,
  Tips,
} from 'Components/Ticket';
import { Page404 } from 'Components/Common';
import { HomePage } from 'Components/Restaurant';
import TicketAvailable from 'Components/Ticket/TicketAvailable';
import TicketCBAvailable from 'Components/Ticket/TicketCBAvailable';

const App = (props) => {
  return (
    <Router>
      <Suspense
        fallback={
          <div id="spinner">
            <Loader />
          </div>
        }
      >
        <TicketJotai>
          <Switch>
            <Route path={['/restaurant/name', '/restaurant']}>
              <HomePage />
            </Route>
            <Route exact path="/ticket/:idTicket">
              <Ticket />
            </Route>
            {/* <Route exact path="/ticket/:idTicket/pay">
              <Payment />
            </Route> */}
            <Route exact path="/ticket/:idTicket/requestTicket/:idPayment">
              <RequestTicket />
            </Route>
            <Route exact path="/ticket/:idTicket/requestTicket/:idPayment/type/:type">
              <TicketAvailable />
            </Route>
            <Route exact path="/ticket/:idTicket/requestCbTicket/:idPayment">
              <TicketCBAvailable />
            </Route>
            <Route exact path="/ticket/:idTicket/pay/form">
              <PaymentForm />
            </Route>
            <Route exact path="/ticket/:idTicket/share">
              <ShareNote />
            </Route>
            <Route exact path="/ticket/:idTicket/share/calculator">
              <Calculator />
            </Route>
            <Route exact path="/ticket/:idTicket/share/perProducts">
              <ShareNoteProduct />
            </Route>
            <Route exact path="/ticket/:idTicket/tips">
              <Tips />
            </Route>
            <Route render={() => <Page404 label="page_not_found" />} />
          </Switch>
        </TicketJotai>
      </Suspense>
    </Router>
  );
};

App.propTypes = {};

export default App;
